"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setWidths = exports.getLetter = exports.loadConvertedFont = exports.create = void 0;
var assert_sidecar_1 = require("../lib/assert-sidecar");
var imports_1 = require("../lib/imports");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var objs = [];
function create(name, options) {
    var data = {};
    imports_1.l.forEach(options.data, function (c) {
        imports_1.l.forEach(c.chars, function (d, dIdx) {
            data[d] = {
                leading: 0,
                w: options.charWidth,
                frame: c.sprite[dIdx],
                oy: 0,
            };
        });
    });
    var obj = {
        name: name,
        data: data,
        charSpacing: options.charSpacing,
        charWidth: options.charWidth,
        charHeight: options.charHeight,
        spaceWidth: options.charWidth,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function loadConvertedFont(name) {
    var data = {};
    var alphaLower = 'abcdefghijklmnopqrstuvwxyz';
    var alphaUpper = alphaLower.toUpperCase();
    var extra = " 1234567890.!?/:,+-%()*'$_";
    var all = alphaLower + alphaUpper + extra;
    var padding = 2;
    for (var i = 0; i < all.length; i++) {
        var d = all[i];
        var s = sprites_sidecar_1.sprites[name + i];
        var sd = s[0];
        data[d] = {
            leading: sd.w / 2,
            w: sd.w - padding * 2,
            frame: sd,
            oy: 0,
        };
    }
    var obj = {
        name: name,
        data: data,
        charSpacing: 0,
        charWidth: 0,
        charHeight: 0,
        spaceWidth: 0, //data[0].w,
    };
    obj.charWidth = getLetter(obj, 'x').w;
    obj.charHeight = getLetter(obj, 'X').frame.h;
    obj.spaceWidth = getLetter(obj, ' ').w;
    objs.push(obj);
    return obj;
}
exports.loadConvertedFont = loadConvertedFont;
function getLetter(obj, letter) {
    var d = obj.data[letter];
    if (!d) {
        letter = letter.toUpperCase();
        d = obj.data[letter];
    }
    if (!d) {
        d = obj.data['?'];
    }
    if (!d) {
        d = obj.data['a'];
    }
    if (!d) {
        assert_sidecar_1.assert.failed('bad font! cant load letter', letter);
    }
    return d;
}
exports.getLetter = getLetter;
function setWidths(obj, chars, newWidth, leading, oy) {
    if (oy === void 0) { oy = 0; }
    imports_1.l.forEach(chars, function (c, cIdx) {
        var letter = c;
        var d = obj.data[letter];
        if (!d) {
            letter = letter.toUpperCase();
            d = obj.data[letter];
        }
        if (!d) {
            assert_sidecar_1.assert.failed('bad font! cant adjust letter', letter);
        }
        d.w = newWidth;
        d.leading = leading;
        d.oy = oy;
    });
}
exports.setWidths = setWidths;
// export function setLeadings(obj: IFontData2, chars: string, leading: number) {
//   l.forEach(chars, (c, cIdx) => {
//     let letter = c.toLowerCase()
//     let d = obj.data[letter]
//     if (!d) {
//       assert.failed('bad font! cant adjust letter', letter)
//     }
//     d.leading = leading
//   })
// }
